import parseNum from 'parse-num'

export function parseNumberDotSeparated (value) {
  let parsed = parseNum(value, ',')
  if (isNaN(parsed)) parsed = null

  return parsed
}
